<template>
  <div class="row page-wrapper">
    <div class="col-12">
      <div class="row page-header">
        <div class="col-12 col-md-6 col-xl-8">
          <h3>Benutzer</h3>
        </div>
        <div class="col-12 col-md-6 col-xl-4">
          <b-button
            to="/add-user"
            class="btn-primary btn-new-company float-right"
          >
            + Neuer Benutzer
          </b-button>
        </div>
      </div>
      <div class="row table-wrapper">
        <!-- <div class="col-12">
          <b-table
            id="user-table"
            ref="table"
            :fields="fields"
            :items="getPage"
            :primary-key="'id'"
            :busy="isLoading"
            :responsive="true"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(createdAt)="data">
              {{ data.value | formatDateTime }}
            </template>
            <template v-slot:cell(actions)="data">
              <div class="btn-actions-container">
                <img
                  svg-inline
                  class="icon btn btn-actions" 
                  :src="editIcon" 
                  @click="editUser(data.item)"
                >
              </div>
              <div class="btn-actions-container">
                <img
                  v-if="authStorageService.getAuth().user_id != data.item.id"
                  svg-inline
                  class="icon btn btn-actions"
                  :src="removeIcon"
                  @click="confirmUserRemoval(data.item)"
                >
              </div>
            </template>
            <template v-slot:table-busy>
              <div class="text-center">
                <b-spinner class="align-middle" />
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCount"
            :per-page="perPage"
            aria-controls="company-table"
          />
        </div> -->
        <div class="col-12 mb-4">
          <GridTable
            :get-page="getPage"
            :isLoading="isLoading"
            :columns="columns"
            :filterable="false"
            :pageable="true"
            :total="totalCount"
            :perPage="perPage"
            :currentPage="currentPage"
            :onDelete="confirmUserRemoval"
            :onEdit="editUser"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {NavigationMixin, UserMixin, AuthMixin} from '../../mixins';
import removeIcon from '../../assets/icons/remove.svg';
import warningIcon from '../../assets/icons/warning.svg';
import editIcon from '../../assets/icons/edit.svg';
import GridTable from '../table/new-data-table';

export default {
  name: 'UserList',
  components: { GridTable },
  mixins: [NavigationMixin, UserMixin, AuthMixin],
  data: function () {
    return {
      fields: [
        {key: 'role', label: 'Rolle'},
        {key: 'email', label: 'Email'},
        {key: 'name', label: 'Name'},
        {key: 'createdAt', label: 'Datum erstellen'},
        {key: 'actions', label: '', class: 'actions-cell'}
      ],
      columns: [
        {field: 'role', title: 'Rolle'},
        {field: 'email', title: 'Email'},
        {field: 'name', title: 'Name'},
        {field: 'createdAt', title: 'Datum erstellen'},
        {field: 'actions', title: ' ', class: 'actions-cell', sortable: false, cell: 'actionCellTemplate'}
      ],
      removeIcon: removeIcon,
      editIcon: editIcon,
      isLoading: false,
      perPage: 5,
      currentPage: 1,
      totalCount: null
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated
    })
  },
  methods: {
    async getPage(ctx) {
      this.isLoading = true;
      const response = await this.userService.getUsers(ctx);
      this.isLoading = false;
      this.totalCount = response.totalCount;
      return response.users;
    },
    async confirmUserRemoval(user) {
      const h = this.$createElement;
      const messageVNode = h('div', [
        h('p', [
          h('b-img', {
            class: ['warning-icon'],
            props: {
              src: warningIcon
            }
          })
        ]),
        h('p', [
          h('strong', 'Möchten Sie den Benutzer wirklich löschen?')
        ]),
        h('p', [
          h('span', user.name)
        ])
      ]);
      const isConfirmed = await this.$bvModal.msgBoxConfirm([messageVNode], {
        centered: true,
        okTitle: 'Löschen',
        cancelTitle: 'Zurück',
        modalClass: 'confirm-modal'
      });
      if (isConfirmed) {
        await this.userService.removeUser(user.id);
        return true;
        // this.$refs.table.refresh();
      }
    },
    async editUser(user) {
      this.$router.push({name: 'edit-user', params: {id: user.id}});
    }
  }
};
</script>

<style scoped lang="scss">
  .btn.btn-primary.btn-new-company {
    font-size: 16px;
    line-height: 19px;
    height: 36px;
    padding: 8px 20px 10px 20px;
  }

  .actions-cell img {
    margin: 0 !important;
  }
</style>
